import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledScoreLinearProgress = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--score-linear-progress-value': utils.isDefined(props.$value) ? `${100 - props.$value}%` : null
    };

    return utils.styleProps(attr, vars);
  })`
  &.ScoreLinearProgress {
    position: relative;
    height: ${props => props.theme.layout(20)};
    
    .LinearProgress {
      background-color: ${props => props.theme.property('palette.divider')};
      height: 100%;
      border-radius: ${props => props.theme.radius(2.5)};
      
      .MuiLinearProgress-bar {
        border-radius: ${props => props.theme.radius(2.5)};
      }
    }
    
    .Typography {
      position: absolute;
      top: 0;
      right: calc(${props => props.$css.$var('--score-linear-progress-value', false)} + ${props => props.theme.layout(6)});
    }
  }

  &.ScoreLinearProgress-size-medium {
    height: ${props => props.theme.layout(16)};
    .LinearProgress {
      height: 100%;
    }
    .Typography {
      font-size: ${props => props.theme.fontSize(10)};
    }
  }
  &.ScoreLinearProgress-size-smallish {
    height: ${props => props.theme.layout(12)};
    .LinearProgress {
      height: 100%;
    }
    .Typography {
      font-size: ${props => props.theme.fontSize(8)};
    }
  }
  &.ScoreLinearProgress-size-small {
    height: ${props => props.theme.layout(8)};
    .LinearProgress {
      height: 100%;
    }
  }
  &.ScoreLinearProgress-size-smaller {
    height: ${props => props.theme.layout(6)};
    .LinearProgress {
      height: 100%;
    }
  }
  
  ${ComponentStyles}
`;

StyledScoreLinearProgress.propTypes = {
  theme: PropTypes.object
};

export default StyledScoreLinearProgress;
